import * as React from 'react';
import { TInputType } from '@cian/ui-kit/input/types';
import { useDeviceType } from '@cian/ui-kit/responsive';
import { FormFieldInput, Button } from '@cian/ui-kit';

import { ChangePhone } from '../ChangePhone';
import { CountDown } from '../CountDown';
import * as styles from './styles.css';

export interface IVerifyFieldProps {
  value: string;
  error: string;
  isValid: boolean;
  seconds: number;
  phone: string;
  fetching: boolean;
  submitText: string;

  onChangePhone(): void;

  onChange(value: string): void;

  onSubmit(code: string, phone: string): void;

  restart(phone: string): void;
}

export const VerifyField: React.FC<IVerifyFieldProps> = props => {
  const { onSubmit, fetching, isValid, error, value, seconds, onChange, restart, onChangePhone, phone, submitText } =
    props;
  const isMobile = useDeviceType() === 'phone';
  const handleChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value),
    [onChange],
  );
  const handleSubmit = React.useCallback(() => onSubmit(value, phone), [onSubmit, value, phone]);
  const handleRestart = React.useCallback(() => restart(phone), [restart, phone]);

  return (
    <div data-testid="VerifyField" className={styles['container']}>
      <ChangePhone phone={phone} onChangeClick={onChangePhone} />
      <div className={styles['field']}>
        <FormFieldInput
          invalid={!!error}
          type={'tel' as TInputType}
          placeholder="Код из смс"
          onChange={handleChange}
          disabled={fetching}
          errorMessage={error}
          value={value}
          autoFocus
        />
      </div>
      <div className={styles['count-down']}>
        <CountDown seconds={seconds} onClick={handleRestart} />
      </div>
      <div className={styles['submit']}>
        <Button size={isMobile ? 'M' : 'XS'} disabled={!isValid} onClick={handleSubmit} loading={fetching}>
          {submitText}
        </Button>
      </div>
    </div>
  );
};

VerifyField.displayName = 'VerifyField';
